import styled from "styled-components"
import { Toolbar } from "../Toolbar"
import { StyleableLink, matchPath } from "../Sidebar"

export const TabBar = Toolbar.extend`
  border-bottom: 1px solid ${props => props.theme.accent};
  padding: 0;
`

export const Tab = styled(StyleableLink)`
  font-weight: bold;
  color: ${props =>
    matchPath(props.pathname, props.to, props.exact)
      ? "#FFF"
      : props.theme.accent};
  background: ${props =>
    !matchPath(props.pathname, props.to, props.exact)
      ? "#FFF"
      : props.theme.accent};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  text-transform: uppercase;
  display: block;
`



// WEBPACK FOOTER //
// ./src/UI/TabBar/index.js